


























































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
interface ISliderDatas {
  avatar: string;
  name: string;
  time: string;
  ihref: string;
  images: {
    type: string;
    title: string;
    href: string;
    src: string;
  }[];
  text: string;
  mode: string;
}
@Component
export default class iSlider extends Vue {
  @Prop({
    required: false,
    type: Number,
    default: 8000
  })
  interval!: number;
  @Prop({
    required: true,
    default: null
  })
  datas!: ISliderDatas[] | null;
  @Prop({
    default: true
  })
  play?: boolean;

  @Watch("play")
  handlePlayChange(val: boolean) {
    this.$nextTick(() => {
      if (val) {
        this.startPlay();
      } else {
        this.stopPlay();
      }
    });
  }

  //control
  private timer = 0;
  private currentIndex: number = 0;
  private transition = "var(--transition-theme-change)";
  private transitionE = "all 0s";
  private firstStyle = {
    transform: "",
    transition: this.transition
  };
  private secondStyle = {
    transform: "translateX(-100%)",
    transition: ""
  };
  private isSecond: boolean = false;

  mounted() {
    if (this.play) this.startPlay();
  }

  private startPlay() {
    if (this.interval && this.datas !== null) {
      this.timer = setInterval(() => {
        this.scrollTo();
      }, this.interval);
    }
  }

  private stopPlay() {
    if (this.interval && this.datas !== null) {
      clearInterval(this.timer);
    }
  }

  private mouseEnter() {
    this.stopPlay();
  }
  private mouseLeave() {
    this.startPlay();
  }
  public scrollTo(index: number | null = null) {
    const length = this.datas!.length,
      percent = 100 / length;
    if (!this.isSecond) {
      if (index === null) {
        if (this.currentIndex + 1 <= length) {
          this.currentIndex++;
          this.firstStyle = {
            transition: this.transition,
            transform: `translateX(${-percent * this.currentIndex}%)`
          };
          this.secondStyle = {
            transition:
              this.currentIndex === length ? this.transition : this.transitionE,
            transform:
              this.currentIndex === length
                ? "translateX(0)"
                : `translateX(${percent}%)`
          };
          if (this.currentIndex === length) {
            this.currentIndex = 0;
            this.isSecond = true;
          }
        }
      } else if (index === -1) {
        if (this.currentIndex - 1 >= -1) {
          this.currentIndex--;
          this.firstStyle = {
            transition: this.transition,
            transform: `translateX(${-percent * this.currentIndex}%)`
          };
          this.secondStyle = {
            transition:
              this.currentIndex === -1 ? this.transition : this.transitionE,
            transform:
              this.currentIndex === -1
                ? `translateX(${-100 - percent * this.currentIndex}%)`
                : `translateX(-100%)`
          };
          if (this.currentIndex === -1) {
            this.currentIndex = length - 1;
            this.isSecond = true;
          }
        }
      }
    } else {
      if (index === null) {
        if (this.currentIndex + 1 <= length) {
          this.currentIndex++;
          this.secondStyle = {
            transition: this.transition,
            transform: `translateX(-${percent * this.currentIndex}%)`
          };
          this.firstStyle = {
            transition:
              this.currentIndex === length ? this.transition : this.transitionE,
            transform:
              this.currentIndex === length
                ? "translateX(0)"
                : `translateX(${percent}%)`
          };
          if (this.currentIndex === length) {
            this.currentIndex = 0;
            this.isSecond = false;
          }
        }
      } else if (index === -1) {
        if (this.currentIndex - 1 >= -1) {
          this.currentIndex--;
          this.secondStyle = {
            transition: this.transition,
            transform: `translateX(${-percent * this.currentIndex}%)`
          };
          this.firstStyle = {
            transition:
              this.currentIndex === -1 ? this.transition : this.transitionE,
            transform:
              this.currentIndex === -1
                ? `translateX(${-100 - percent * this.currentIndex}%)`
                : `translateX(-100%)`
          };
          if (this.currentIndex === -1) {
            this.currentIndex = length - 1;
            this.isSecond = false;
          }
        }
      }
    }
  }
}
